import { render, staticRenderFns } from "./DepurationsDetailModal.vue?vue&type=template&id=6e4e7926&scoped=true"
import script from "./DepurationsDetailModal.vue?vue&type=script&lang=js"
export * from "./DepurationsDetailModal.vue?vue&type=script&lang=js"
import style0 from "./DepurationsDetailModal.vue?vue&type=style&index=0&id=6e4e7926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4e7926",
  null
  
)

export default component.exports